export enum enAnnouncementType {
  INFORMATIVE = 'INFORMATIVE',
  POSITIVE = 'POSITIVE',
  NEGATIVE = 'NEGATIVE',
  WARNING = 'WARNING'
}
